<template>
  <div :class="$style.top_banner">
    <div
      :class="$style.banner"
      :style="{ backgroundImage: 'url(https://cdn.ganttpro.com/app/imgs/pricing/BF_top_banner.png)' }"
    >
      <div :class="$style.wrapper">
        <div :class="$style.left_side">
          Black Weeks
        </div>
        <div :class="$style.right_side">
          <div :class="$style.text">
            {{ locales('bf_top_banner_description') }}
          </div>
          <chip
            :readonly="true"
            :bold="true"
            :styles="{fontSize: '16px', lineHeight: '24px'}"
            :text="locales('bf_banner_period')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chip from './BFButton.vue';

export default {
  components: { chip },
  data() {
    return {
      locales: __,
    };
  },
};
</script>

<style module lang="less">
@import '../../../../less/_mixins.less';
@import '../../../../less/_fonts.less';
@import '../../../../less/_variables.less';

 .top_banner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background: #000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  .banner {
    max-width: 1660px;
    width: 1660px;
    min-width: 1660px;
    height: 100px;
    display: flex;
    justify-content: center;
    background-size: cover;
  }

  .wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: calc(100% - 40px);
    max-width: 1058px;
    padding: 0 12px;

    .left_side {
      .FontLatoBold;
      font-size: 68px;
      font-style: normal;
      line-height: 80px; /* 117.647% */
      white-space: nowrap;

      background: linear-gradient(94deg, rgba(153, 187, 183, 0.10) -19.88%, #FFF 48.68%, rgba(255, 255, 255, 0.63) 117.23%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .right_side {
      display: flex;
      align-items: center;
      padding-bottom: 10px;

      .text {
        .FontLatoBold;
        text-align: center;
        font-size: 28px;
        font-style: normal;
        line-height: 32px; /* 114.286% */

        background: linear-gradient(269deg, #FFF 0.4%, rgba(255, 255, 255, 0.40) 132.12%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        margin-right: 24px;
        padding-bottom: 6px;
      }
    }
  }
 }
</style>
